import { CrossIcon, LeftTailArrowIcon } from '@/assets/icons/icons';
import { Flex } from 'antd';
import { useEffect, useRef } from 'react';

interface DownloadReportModalHeaderProps {
  setReportModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onBack?: () => void;
  title: string;
  showBackIcon: boolean;
  /** Mount point for column Presets control (portal from right panel). */
  presetAnchorRef?: React.RefCallback<HTMLSpanElement>;
}

const DownloadReportModalHeader: React.FC<DownloadReportModalHeaderProps> = ({
  setReportModalOpen,
  onBack,
  title,
  showBackIcon,
  presetAnchorRef,
}) => {
  const closeRef = useRef<HTMLButtonElement>(null);

  // Ant Design's focus trap auto-focuses the first focusable control on open.
  useEffect(() => {
    const blurIfAutoFocused = () => {
      const closeBtn = closeRef.current;
      if (closeBtn && document.activeElement === closeBtn) {
        closeBtn.blur();
      }
    };

    blurIfAutoFocused();
    const timeoutId = window.setTimeout(blurIfAutoFocused, 0);

    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <div className='download-report-modal-header'>
      {showBackIcon ? (
        <button
          type='button'
          aria-label='Back'
          onClick={() => (onBack ? onBack() : setReportModalOpen(false))}
          className='download-report-modal-header__icon-btn download-report-modal-header__icon-btn--back'
        >
          <LeftTailArrowIcon color='var(--text-primary)' />
        </button>
      ) : null}

      <Flex
        vertical
        gap='1px'
        className={`download-report-modal-header__content${showBackIcon ? ' has-back' : ''}`}
      >
        <Flex
          align='center'
          justify='space-between'
          gap={10}
          className='download-report-modal-header__row'
        >
          <div className='download-report-modal-header__title-wrap'>
            <p className='download-report-modal-header__title' title={title}>
              {title}
            </p>
          </div>

          <button
            ref={closeRef}
            type='button'
            aria-label='Close'
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => setReportModalOpen(false)}
            className='download-report-modal-header__icon-btn download-report-modal-header__close'
          >
            <CrossIcon />
          </button>
        </Flex>

        <Flex
          align='center'
          gap={12}
          className='download-report-modal-header__row download-report-modal-header__subtitle-row'
        >
          <div className='download-report-modal-header__subtitle-wrap'>
            <p className='download-report-modal-header__subtitle'>
              Filter which shipments you want included then choose what data is
              shown in the download
            </p>
          </div>
          {presetAnchorRef ? (
            <span
              ref={presetAnchorRef}
              className='download-report-modal-header__preset-anchor'
            />
          ) : null}
        </Flex>
      </Flex>
    </div>
  );
};

export default DownloadReportModalHeader;
